import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styles from "./Register.module.scss";
import EyeIcon from "../../../assets/icons/EyeIcon";
import { registration } from "../../../api/authApi";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../contexts/NotificationToast";

const Register = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const { showNotification } = useNotification();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      repeatPassword: "",
      terms: false,
      notifications_enabled: false,
    },
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      console.log("data", data);

      const response = await registration(data);

      const { access_token, refresh_token } = response.data;
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      console.log(response);
      if (response?.status === 201) {
        navigate("/activate");
      }
    } catch (error) {
      console.log(error.response.data.email[0]);

      showNotification(error.response.data.email[0], error.status);
    } finally {
      setIsLoading(false);
    }
  };

  const password = watch("password");

  return (
    <div className={styles.loginPage}>
      <h1>{t("registration.registration")}</h1>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.formUserInfo}>
          <div className={styles.loginInputContainer}>
            <label>{t("registration.first_name")}</label>
            <input
              className={styles.loginInput}
              {...register("first_name", {
                required: t("registration.first_name_required"),
              })}
            />
            {errors.FirstName && (
              <p className={styles.error}>{errors.FirstName.message}</p>
            )}
          </div>

          <div className={styles.loginInputContainer}>
            <label>{t("registration.last_name")}</label>
            <input
              className={styles.loginInput}
              {...register("last_name", {
                required: t("registration.last_name_required"),
              })}
            />
            {errors.LastName && (
              <p className={styles.error}>{errors.LastName.message}</p>
            )}
          </div>
        </div>
        <div className={styles.loginInputContainer}>
          <label>{t("registration.email")}</label>
          <input
            className={styles.loginInput}
            {...register("email", {
              required: t("registration.email_required"),
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: t("registration.invalid_email"),
              },
            })}
          />
          {errors.email && (
            <p className={styles.error}>{errors.email.message}</p>
          )}
        </div>
        <div className={styles.loginInputContainer}>
          <label>{t("registration.password")}</label>
          <input
            type={showPassword ? "text" : "password"}
            className={styles.loginInput}
            {...register("password", {
              required: t("registration.password_required"),
              minLength: {
                value: 6,
                message: t("registration.password_min_length"),
              },
            })}
          />
          <EyeIcon
            className={styles.inputEye}
            onClick={() => setShowPassword(!showPassword)}
          />
          {errors.password && (
            <p className={styles.error}>{errors.password.message}</p>
          )}
        </div>
        <div className={styles.loginInputContainer}>
          <label>{t("registration.repeat_password")}</label>
          <input
            type={showRepeatPassword ? "text" : "password"}
            className={styles.loginInput}
            {...register("repeatPassword", {
              required: t("registration.repeat_password_required"),
              validate: (value) =>
                value === password || t("registration.password_mismatch"),
            })}
          />
          <EyeIcon
            className={styles.inputEye}
            onClick={() => setShowRepeatPassword(!showRepeatPassword)}
          />
          {errors.repeatPassword && (
            <p className={styles.error}>{errors.repeatPassword.message}</p>
          )}
        </div>
        <div className={styles.checkbox}>
          <input
            type="checkbox"
            {...register("terms", {
              required: t("registration.terms_required"),
            })}
          />
          <p className={errors.terms ? styles.errorText : styles.registerText}>
            {t("registration.terms_agreement")}
          </p>
        </div>
        <div className={styles.checkbox}>
          <input type="checkbox" {...register("notifications_enabled")} />
          <p className={styles.registerText}>
            {t("registration.newsletter_agreement")}
          </p>
        </div>
        <CustomButton
          type="submit"
          className={styles.loginButton}
          isLoading={isLoading}
          blue
        >
          {t("registration.register")}
        </CustomButton>
        <p className={styles.registerText}>
          {t("registration.already_have_account")}
        </p>
      </form>
    </div>
  );
};

export default Register;
